import React from 'react';
import { motion } from 'framer-motion';

const Hero = ({ title, subtitle, imageUrl }) => {
  return (
    <div className="relative w-full aspect-video overflow-hidden bg-slate-950">
      {/* Background Image - Set to contain to show entire 1280x720 image */}
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        src={imageUrl}
        alt={title}
        className="w-full h-full object-contain"
      />
      
      {/* Subtle Gradient Overlay to ensure text readability without hiding the image */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent pointer-events-none" />
      
      {/* Content Overlay */}
      <div className="absolute inset-0 flex flex-col items-center justify-end md:justify-center text-center p-4 pb-8 md:p-6">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="bg-slate-900/40 backdrop-blur-sm p-4 md:p-8 rounded-3xl border border-white/10"
        >
          <h1 className="text-2xl md:text-6xl font-black text-white uppercase tracking-tighter mb-2 md:mb-4 drop-shadow-2xl">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm md:text-2xl font-bold text-blue-400 uppercase tracking-widest drop-shadow-lg">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;